import { c as _c } from "react/compiler-runtime";
import { Tether, PopoverAnimation, Padding, Box, usePopover, Portal, EmployeeAvatar, Menu2 as Menu } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
import { useAuthAvatarType, useAuthProfilePic } from './avatar';
import { useAccountMenuItems } from './menu-items';
export function AccountMenu() {
  const $ = _c(21);
  const employeeType = useAuthAvatarType();
  const imageUrl = useAuthProfilePic();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      excludeTarget: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    popoverRef,
    isPopoverOpen,
    togglePopover,
    targetRef
  } = usePopover(t0);
  const menuItems = useAccountMenuItems();
  let t1;
  if ($[1] !== employeeType || $[2] !== imageUrl || $[3] !== targetRef || $[4] !== togglePopover) {
    t1 = <EmployeeAvatar employeeType={employeeType} imageUrl={imageUrl} sizeInPixels={32} onClick={togglePopover} ref={targetRef} />;
    $[1] = employeeType;
    $[2] = imageUrl;
    $[3] = targetRef;
    $[4] = togglePopover;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: 200
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== menuItems) {
    t3 = <Padding y={8}><Menu items={menuItems} /></Padding>;
    $[7] = menuItems;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== popoverRef || $[10] !== t3) {
    t4 = <Box backgroundColor="white" borderRadius={3} elementRef={popoverRef} boxShadow="overlay" style={t2}>{t3}</Box>;
    $[9] = popoverRef;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isPopoverOpen || $[13] !== t4) {
    t5 = <PopoverAnimation isOpen={isPopoverOpen} direction="up">{t4}</PopoverAnimation>;
    $[12] = isPopoverOpen;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5 || $[16] !== targetRef) {
    t6 = <Portal name="popover"><Tether targetRef={targetRef} targetAnchor="bottomRight" anchor="topRight" yOffset={10} xOffset={0}>{t5}</Tether></Portal>;
    $[15] = t5;
    $[16] = targetRef;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t1 || $[19] !== t6) {
    t7 = <>{t1}{t6}</>;
    $[18] = t1;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}